<app-entity-translations-widget
    [entity]="props.entity"
    [recordId]="formControl.value"
    (translationsChange)="onTranslationsChange($event)"
/>
